import { Container, Mesh, Program, IcoSphereGeometryBuffer, Texture } from 'beam';
import CubicBezier from './helpers/cubicBezier';
import globeVertexShader from './shaders/globe-vs.glsl'
import globeFragmentShader from './shaders/globe-fs.glsl'
import WheelIndicator from 'wheel-indicator'; 
import SwipeIndicator from './helpers/swipe-indicator'; 
import support from './helpers/support'; 

import App from '../stores/app.js';
import getPosition from './helpers/getPosition';

export default class GLSteppedScroll extends HTMLElement {

    constructor() {
        super();
        this.resize    = this.resize.bind(this);
        this.update    = this.update.bind(this);
        this.onwheel   = this.onwheel.bind(this)
        this.onSwipe   = this.onSwipe.bind(this)
        this._top      = 0;
        this.currStep = 0;
        this.sections = [];
    }

    connectedCallback() {

        this._isActive = true;
        this.__isConnected__ = true;

        this._wheelIndicator = new WheelIndicator({
            elem:  this,
            preventMouse: !window.wp,
            callback: this.onwheel,
        });
        if (support.touch) {
            this._swipeIndicator = new SwipeIndicator({
                elem:     document,
                callback:   this.onSwipe,
                preventMouse: !window.wp,
                direction: 'y'
            });
        }   

        requestAnimationFrame(()=>{
            App.lenis.stop()
            this.update();

            this.resize();
            window.addEventListener('resize', this.resize);

        });

    }

    onSwipe(e) {
        console.log('onSwipe')
        this.isSwipping = true;
        this.swipeEvent = e;
        clearTimeout(this.timer);
        clearTimeout(this.endTimer)
        this.timer = setTimeout(()=>{
            console.log('Delayed swipe')
            this.onwheel(e, true);
            this.endTimer = setTimeout(()=>{
                this.isSwipping = false;
            }, 1000);
        }, 300);
    }

    onwheel(e, force) {

        if (Date.now()-this.lastWheel < 700) {
            return
        }
        
        if (!this._isActive) {
            return;
        }
        
        this.lastWheel = Date.now();

        this.currStep += e.direction == 'down' ? 1 : -1;
        this.currStep = Math.max(0, this.currStep);

        if (this.sections[this.currStep]) {
            const sectionTop = getPosition(this.sections[ this.currStep ]).top + (this.currStep == this.sections.length-1 ? 1 : 0); 
            if (this.currStep == this.sections.length-1 ? 1 : 0) {
                console.log('GO TO END', this.sections[ this.currStep ], sectionTop)
            }
            else {
                console.log('GO TO', this.sections[ this.currStep ], sectionTop)
            }
            App.lenis.stop();
            App.lenis.scrollTo(sectionTop, {
                duration: 2,
                force: true,
                easing: (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2 // https://easings.net/en#easeInOutQuad
            });
        }
        else {
            App.lenis.start();
        }
    }

    disconnectedCallback() {
        this.__isConnected__ = false;
        this._swipeIndicator?.turnOff()
        this._wheelIndicator?.turnOff()
    }

    resize() {
        console.log('RESIZE WHILE SWIPE ?', this.isSwipping)
        clearTimeout(this.timer);
        if (this.isSwipping) {
            if (this.sections[this.currStep]) {
                const sectionTop = getPosition(this.sections[ this.currStep ]).top;
                console.log('FORCED GO TO', this.sections[ this.currStep ], sectionTop)
                App.lenis.stop();
                App.lenis.scrollTo(sectionTop, {
                    duration: 2,
                    force: true,
                    easing: (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2 // https://easings.net/en#easeInOutQuad
                });
            }
            else {
                App.lenis.start();
            }
        }
    }

    addSection(el) {
        this.sections.push(el);
    }

    update() {

        if (!this.__isConnected__) {
            return;
        }
        requestAnimationFrame(this.update);

        if ( !this.sections[ this.sections.length - 1 ]) {
            return;
        }


        if (App.lenis.animatedScroll > getPosition(this.sections[ this.sections.length - 1 ]).top) {
            if (this._isActive) {
                this._isActive = false;
                App.lenis.start();
            }
        }
        else {
            if (!this._isActive) {
                this._isActive = true;
                this.currStep = this.sections.length - 1
                App.lenis.stop();
                App.lenis.scrollTo( getPosition(this.sections[ this.sections.length - 1 ]).top, {
                    duration: 0.1,
                    force: true,
                    easing: (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2 // https://easings.net/en#easeInOutQuad
                });

            }
        }
        

    }

}

customElements.define('gl-stepped-scroll', GLSteppedScroll);